<div [hidden]="!showBanner" class="notification-banner">
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="ui-grid-row ui-g-12 message-container-div" [innerHTML]="genericSystemMessage"></div>
  </div>
</div>
